import React from "react";
import clsx from "clsx";

import { useCrossEntityNotificationsCount } from "@/components/utilities/notifications";

const SIZE_STYLES = {
	default: "text-label-sm h-[20px] w-[20px] lg:h-[22px] lg:w-[22px]",
	sm: "text-xs h-4 min-w-[16px] px-[6px]",
};

type NotificationsCountPillProps = React.ComponentPropsWithoutRef<"div"> & {
	size?: keyof typeof SIZE_STYLES;
};

const NotificationsCountPill = ({
	className = "",
	size = "default",
	...props
}: NotificationsCountPillProps) => {
	// Cross-entity count: the account plus all investing entities.
	const incompleteNotificationsCount = useCrossEntityNotificationsCount();

	if (incompleteNotificationsCount === 0) {
		return null;
	}

	return (
		<div
			aria-label={`${incompleteNotificationsCount} notifications`}
			data-testid="nav-count-pill"
			className={clsx(
				"bg-warning flex items-center justify-center rounded-full leading-none text-white",
				SIZE_STYLES[size] ?? SIZE_STYLES.default,
				className,
			)}
			{...props}
		>
			{incompleteNotificationsCount}
		</div>
	);
};

export default NotificationsCountPill;
